import { render, staticRenderFns } from "./LogisticsTemplateManageSave.vue?vue&type=template&id=4d025a50&scoped=true"
import script from "./LogisticsTemplateManageSave.vue?vue&type=script&lang=js"
export * from "./LogisticsTemplateManageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d025a50",
  null
  
)

export default component.exports